import includedVcLogo from "./assets/included-vc-logo.png";
import includedMLogo from "./assets/included-m-logo.png";

export const DEFAULT_COURSE_ID = "main-course";

export const INCLUDED_VC_LOGO = includedVcLogo;
export const INCLUDED_M_LOGO = includedMLogo;
